module.exports = __webpack_public_path__ + "img/agent_two.bae89d49.webp";